import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

import Translate from 'containers/Translate';
import HeaderContainer from 'containers/HeaderContainer';

require('./index.scss');

export default class Panel extends Component {
  render() {
    return(
      <div className="app-Panel">
        {this.props.noHeader ? null :
          <HeaderContainer />
        }
        <div className="app-Panel-container">
          <div className={`app-Panel-content ${this.props.className}`}>
            {this.props.children}
          </div>

          { this.props.noSidebar === true ? null :
            <div className="app-Panel-sidebar">
              <div>
                <NavLink className="app-Panel-sidebar-link" to="/pay-dues">
                  <Translate language="en">
                    Pay Dues
                  </Translate>
                  <Translate language="es">
                    Pagar Cuotas
                  </Translate>
                </NavLink>
                <a className="app-Panel-sidebar-link" href="https://local197-public-website-files.s3.amazonaws.com/pdf/197-ratified-bylaws.pdf" target="_blank" rel="noopener noreferrer">
                  <Translate language="en">
                    Ratified Bylaws
                  </Translate>
                  <Translate language="es">
                    Estatutos Ratificados
                  </Translate>
                </a>
                <Translate language="en">
                  <a className="app-Panel-sidebar-link" href="https://marcc.carpenters.fund/" target="_blank" rel="noopener noreferrer">
                    MARCC Benefits
                  </a>
                </Translate>
                <Translate language="es">
                  <a className="app-Panel-sidebar-link" href="https://marcc.carpenters.fund/" target="_blank" rel="noopener noreferrer">
                    Beneficios de MARCC
                  </a>
                </Translate>
                <a className="app-Panel-sidebar-link" href="https://local197-public-website-files.s3.amazonaws.com/pdf/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">
                  <Translate language="en">
                    Privacy Policy
                  </Translate>
                  <Translate language="es">
                    Política de Privacidad
                  </Translate>
                </a>
              </div>
              <Translate language="en">
                <iframe src="https://www.youtube.com/embed/3-X5hCxdaLc" frameBorder="0" allowFullScreen title="English Video"></iframe>
              </Translate>
              <Translate language="es">
                <iframe src="https://www.youtube.com/embed/iaBCBXy600E" frameBorder="0" allowFullScreen title="Spanish Video"></iframe>
              </Translate>
              <div className="app-Panel-sidebar-links">
                <a className="app-Panel-sidebar-link" href="https://www.facebook.com/UBC197/" target="_blank" rel="noopener noreferrer">
                  <Translate language="en">
                    Facebook
                  </Translate>
                  <Translate language="es">
                    Facebook
                  </Translate>
                </a>
                <a className="app-Panel-sidebar-link" href="http://blog.197-carpenters.com/" target="_blank" rel="noopener noreferrer">
                  <Translate language="en">
                    View our Blog
                  </Translate>
                  <Translate language="es">
                    Lee Nuestro Blog
                  </Translate>
                </a>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}
